import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { BaseService } from './base-service';
export class AnnouncerService {
    static init() {
        // avoid multiple initializations
        if (this.initialized === true) {
            return;
        }
        this.initialized = true;
        const url = BaseService.relativePermaBaseUrl(this.ANNOUNCE_URL);
        this.connection = new HubConnectionBuilder()
            //.withUrl(url)
            .withUrl(url, { withCredentials: false }) // this apparently handles CORS properly
            .withAutomaticReconnect()
            .configureLogging(this.LOGGING_LEVEL)
            .build();
        this.connection.on(this.COMMAND, (event) => this.onEvent(event));
        this.connection.onclose(error => {
            console.info("AnnouncerService: received connection on-close: ", error);
            // this.disconnect();
        });
    }
    static async connect(newUuserId) {
        // avoid multiple reconnections
        if (this.connected === true && this.userId === newUuserId) {
            return;
        }
        if (this.initialized === false) {
            this.init();
        }
        else {
            await this.disconnect();
        }
        this.userId = newUuserId;
        try {
            this.connected = true;
            await this.connection.start();
            await this.connection.invoke('subscribe', `${this.userId}`, `${this.USER_TOPIC}:${this.userId}`);
            await this.connection.invoke('subscribe', `${this.userId}`, this.EVENTS_TOPIC);
            console.info("AnnouncerService: connected with userId: " + this.userId);
        }
        catch (e) {
            this.connected = false;
            console.error("AnnouncerService: error connecting or subscribing", e);
        }
    }
    static async disconnect() {
        if (this.initialized === false)
            return;
        try {
            this.connected = false;
            await this.connection.stop();
            console.info("AnnouncerService: disconnected");
        }
        catch (e) {
            console.warn("AnnouncerService: error disconnecting", e);
        }
    }
    static deserializeEvent(event) {
        try {
            return JSON.parse(event);
        }
        catch (error) {
            return {};
        }
    }
    static onEvent(serializedEvent) {
        // console.info('Announcer: received raw event', serializedEvent);
        const event = this.deserializeEvent(serializedEvent);
        console.info('Announcer: received event', event);
        switch (event.eventCode) {
            case 'INBOUND_PHONE_CALL':
                this.evtInboundPhoneCall.next(event);
                break;
            default:
            // do nothing
        }
    }
}
AnnouncerService.ANNOUNCE_URL = '_announce';
AnnouncerService.COMMAND = 'publish';
AnnouncerService.EVENTS_TOPIC = 'EVENTS_TOPIC';
AnnouncerService.USER_TOPIC = 'USER_TOPIC';
AnnouncerService.LOGGING_LEVEL = LogLevel.Error;
AnnouncerService.initialized = false;
AnnouncerService.connected = false;
AnnouncerService.evtInboundPhoneCall = new Subject();
